import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'are_any_monetary_deposits_required_of_wrkrs'

export const dataPointDefinition = {
  retracedId: 'are_any_monetary_deposits_required_of_wrkrs',
  name: 'Are any monetary deposits required of workers?',
  description:
    'Monetary deposits include those requested in home and/or receiving countries.\r\r\n\r\r\nDeposits of a reasonable amount do not constitute forced labor if the workers are informed of the conditions for return of the deposit, and if the deposit is indeed refunded once they have fulfilled these conditions. In the case of a deposit required for a uniform, the worker should be made aware that should they choose to leave, the deposit will be refunded to them upon returning the uniform. ',
  meta: {},
  fieldTypeId: 'YES_NO',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes',
      key: 'YES',
      slcpIndex: 1,
      slcpOptionName: 'yes-no',
    },
    {
      name: 'No',
      key: 'NO',
      slcpIndex: 2,
      slcpOptionName: 'yes-no',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['YES', 'NO'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'fl-1',
      version: '1.4.0',
      provider: 'slcp',
    },
  ],
  sortingId: 4860,
  sectionId: '2.2.4.1',
  impactArea: 'Recruitment, Hiring & Termination Practices',
  impactAreaId: 'RECRUITMENT_HIRING_AND_TERMINATION_PRACTICES',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
